export const formatToISOString = (date) => {
    return date ? date.toISOString() : '';
};

export const formatTime = (seconds) => {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;

    return hours + "h " + minutes + "m " + remainingSeconds + "s";
}

export const formatDuration = (duration) => {
    const seconds = Math.floor(duration % 60);
    const minutes = Math.floor((duration / 60) % 60);
    const hours = Math.floor(duration / 3600);
    return [hours, minutes, seconds].map(v => String(v).padStart(2, '0')).join(':');
  };



  export const addMonths = (date, months) => {
    const newDate = new Date(date); 
    newDate.setMonth(newDate.getMonth() + months); 
    newDate.setHours(23, 59, 59, 0); 
    return newDate;
  };


  // CORRECT - Manual formatting to avoid timezone issues
  export const getMonthDateRange = (date) => {
      if (!date) return null;
  
      const year = date.getFullYear();
      const month = date.getMonth();
  
      const startDate = new Date(year, month, 1);
      const endDate = new Date(year, month + 1, 0);
  
      // SOLUTION: Manual formatting without timezone conversion
      const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
      };
  
      return {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate)
      };
  };
  
  
  export const getMonthDisplay = (dateString, format = 'full') => {
      if (!dateString) return '';
  
      const date = new Date(dateString);
      const month = date.getMonth();
      const year = date.getFullYear();
  
      const monthNames = {
          full: ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'],
          short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          hindi: ['जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून',
              'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर']
      };
  
      const monthName = monthNames[format] ? monthNames[format][month] : monthNames.full[month];
  
      return `${monthName} ${year}`;
  };
  
